export enum AppsConnectedActionTypes {
  APPS_CONNECTED_DISCONECT = 'app/apps-connected/APPS_CONNECTED_DISCONECT',
  APPS_CONNECTED_DISCONECT_FAILURE = 'app/apps-connected/APPS_CONNECTED_DISCONECT_FAILURE',
  APPS_CONNECTED_DISCONECT_SUCCESS = 'app/apps-connected/APPS_CONNECTED_DISCONECT_SUCCESS',
  APPS_CONNECTED_REQUEST = 'app/apps-connected/APPS_CONNECTED_REQUEST',
  APPS_CONNECTED_REQUEST_FAILURE = 'app/apps-connected/APPS_CONNECTED_REQUEST_FAILURE',
  APPS_CONNECTED_REQUEST_SUCCESS = 'app/apps-connected/APPS_CONNECTED_REQUEST_SUCCESS',
}
